import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  Paper,
  Divider,
} from "@mui/material";
import { formatDateToDDMMYYYY } from "../../../../../../shared/utils/dateFormat";
import { formatAmountINR } from "../../../../../../shared/utils/amountFormat";

interface FeeTermProps {
  term: {
    name: string;
    amount: number;
    dueOn: string;
    split: Record<string, number>;
  };
}

const FeeViewTerm: React.FC<FeeTermProps> = ({ term }) => {
  return (
    <Card variant="outlined" sx={{ marginBottom: 3, boxShadow: 2, backgroundColor: "#f0f3fa" }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {term.name}
        </Typography>

        <Typography variant="body1">
          <strong>Amount:</strong> {formatAmountINR(term.amount)}
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
        <strong>Due On:</strong> {formatDateToDDMMYYYY(term?.dueOn)}
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="subtitle1" gutterBottom>
          Fee Breakdown
        </Typography>

        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableBody>
              {[...Object.entries(term.split || {})].reverse().map(([key, value]) => (
                <TableRow key={key}>
                  <TableCell component="th" scope="row">{key}</TableCell>
                  <TableCell align="right">{formatAmountINR(value)}</TableCell>
                </TableRow>
              ))}

              {/* Grand Total row */}
              <TableRow>
                <TableCell component="th" scope="row">
                  <strong>Grand Total</strong>
                </TableCell>
                <TableCell align="right">
                  <strong>{formatAmountINR(term.amount)}</strong>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default FeeViewTerm;